export default "__VITE_ASSET__nOGwVEAO__"